import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {Government_OLD} from '@association/_common/models/government.models';

export const loadList = createAction(
    '[Government Body] Load List',
    props<{ uuid: string, clearState?: boolean }>()
);

export const loadListSuccess = createAction(
    '[Government Body] Load List Success',
    props<{ items: Government_OLD[] }>()
);

export const loadListFailure = createAction(
    '[Government Body] Load List Failure',
    props<{ error: HttpErrorResponse }>()
);
